import { ReactNode } from 'react';
import AppHeader from '@/components/Elements/Header/AppHeader';

interface Props {
  children: ReactNode;
  title?: string;
  backButton?: boolean;
  noMyPage?: boolean;
  handleBack?: () => void;
}

function Layout({ children, title, backButton, noMyPage= false, handleBack }: Props) {
  return (
    <>
      <AppHeader title={title} showBackButton={backButton} handleBack={handleBack} noMyPage={noMyPage}/>
      {children}
    </>
  );
}

export default Layout;
